export const listener = (inputElement, keyDownEvent, inputEvent, focusEvent, blurEvent) => {
  function handleFocus(e) {
    focusEvent(e.target);
  }

  function handleBlur(e) {
    blurEvent(e.target);
  }

  function handleInput(e) {
    inputEvent(e.target);
  }

  function handleKeyDown(e) {
    keyDownEvent(e.target);
  }

  inputElement.addEventListener('focus', handleFocus);
  inputElement.addEventListener('blur', handleBlur);
  inputElement.addEventListener('keydown', handleKeyDown);
  inputElement.addEventListener('input', handleInput);
  return () => {
    inputElement.removeEventListener('focus', handleFocus);
    inputElement.removeEventListener('blur', handleBlur);
    inputElement.removeEventListener('keydown', handleKeyDown);
    inputElement.removeEventListener('input', handleInput);
  };
};